<template>
  <div class="header">
    <!-- <div class="logo">
      <img src="@/assets/images/logo.svg" alt=""/>
    </div> -->

    <div v-if="storeName" class="storename">
      {{storeName}}
      <span class="change-store-btn" @click="menuJump('/home')">変更</span>
    </div>

    <h1 v-if="pageName && memberSpareObj.memberSpareStyle != undefined" class="pagename" :style="{lineHeight: memberSpareObj.memberSpareStyle}">
      <img v-if="pageNameLeftBtnRouter" @click="menuJump(pageNameLeftBtnRouter)" class="arrleft" src="../assets/images/arrow-l.svg" alt="">
      {{pageName}}
    </h1>
    <h1 v-else class="pagename">
      <img v-if="pageNameLeftBtnRouter" @click="menuJump(pageNameLeftBtnRouter)" class="arrleft" src="../assets/images/arrow-l.svg" alt="">
      {{pageName}}
    </h1>
    <p class="member-spare" v-if="memberSpareObj.memberSpareCode != null && memberSpareObj.memberSpareCode != undefined && memberSpareObj.memberSpareCode != ''">会員ID：{{memberSpareObj.memberSpareCode}}</p>
    <div v-if="stepName" class="stepname">
      <div v-if="leftBtnRouter" class="arr-l">
        <a href="javascript:void(0);" @click="menuJump(leftBtnRouter)"><img src="../assets/images/arrow-l.svg" alt=""/></a>
      </div>
      <span v-if="stepNo">{{stepNo}}</span><span style="font-size: 13px; padding-top: 1px;">{{stepName}}</span>
      <div class="arr-r">
        <img src="../assets/images/arrow-r.svg" alt=""/>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: "headerBar",
    data() {
      return {
      }
    },
    props: {
      storeName: String,
      pageName: String,
      memberSpareObj: {
        type: Object,
        default(){
          return {}
        }
      },
      stepNo: String,
      stepName: String,
      leftBtnRouter: String,
      rightBtnRouter: String,
      pageNameLeftBtnRouter: String
    },
    mounted() {
      this.$router.afterEach(() => {
        window.scrollTo(0, 0)
      })
    },
    methods:{
      menuJump(routerUrl){
        if (routerUrl == '/home') {
          //window.location.href = '/home';
          let currentVersion = localStorage.getItem('version');
          this.$router.push({ path: '/home', query: { v: currentVersion } });
        }else{
          this.$router.push({path: routerUrl})
        }  
      }
    }
  }
</script>

<style scoped>
  .change-store-btn {
    position: absolute;
    right: 0;
    top: 0px;
    margin: 8px 10px 8px;
    float: right;
    width: 42px;
    background-color: #fff;
    line-height: 20px;
    border-radius: 15px;
    border: 2px solid #C10230;
    color: #C10230;
    font-size: 12px;
    display: flex;
    justify-content: center;
  }
  .member-spare {
    position: relative;
    padding: 0px 5px 10px 5px;
    line-height: 10px;
    font-size: 15px;
  }
</style>
